module.exports = __webpack_public_path__ + "img/no-data.8a0ef808.png";